import { PageDetailContent } from '@client/toolkit';

import { AgreementNameField } from '../components/agreement-name/agreement-name-field.component';
import { AgreementFilesCard } from '../components/agreement-files/agreement-files-card.component';
import { PageContentAnimation } from '../../../../components';
import { AgreementWizardActions } from '../components/agreement-wizard-actions.component';

export function AgreementDocumentsRoute() {
  return (
    <PageDetailContent>
      <PageContentAnimation className="space-y-4 px-4 pt-2 pb-8 rounded-lg shadow-lg border border-border">
        <div className="flex items-center">
          <AgreementNameField className="flex-1" />
          <AgreementWizardActions />
        </div>
        <AgreementFilesCard />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
